import script from "./AppButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppButton.vue?vue&type=script&setup=true&lang=ts"

import "./AppButton.vue?vue&type=style&index=0&id=aa2eba8a&scoped=true&lang=css"

import exportComponent from "/builds/kligmanbb/medsafe-smart-pro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa2eba8a"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QSpinnerHourglass from 'quasar/src/components/spinner/QSpinnerHourglass.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QMenu,QCard,QSpinnerHourglass});
